import React from "react";

const Overview = () => (
  <div className="overview">
    {/* <h2 className="section-title">Our Success is Reflected in Our Clients</h2> */}
    <p> 
      At Chiselon Technologies, we don’t just deliver services — we build long-term relationships that drive real business impact. 
      With a client retention rate of 90%+, we are proud to partner with global enterprises, consulting firms, and fast-growing startups.
    </p>
  </div>
);

export default Overview;
